module.exports = __webpack_public_path__ + "static/media/molecular_gen_2.841bd0da.jpeg";